import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import SectionHeading from './SectionHeading';

const Certificates = function({ lang, isDark, sections, certificates }) {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="certificates" className="mb-10" aria-labelledby="certificates-heading">
      <div className="section-card">
        <SectionHeading id="certificates-heading" isDark={isDark}>{sections.certificates}</SectionHeading>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {certificates.map((cert, i) => (
            <div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className={`flex flex-col rounded-lg overflow-hidden border cursor-zoom-in transition-colors duration-300 ${isDark ? 'border-white/10 hover:border-blue-500/40' : 'border-slate-200 hover:border-blue-400'}`}
            >
              <img
                src={cert.image}
                alt={cert.title}
                loading="lazy"
                className="w-full aspect-[4/3] object-cover"
              />
              <div className="p-2.5">
                <h3 className={`text-[12px] font-bold leading-snug line-clamp-2 ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
                  {cert.title}
                </h3>
                <p className={`text-[10px] font-mono mt-1 ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
                  {cert.date}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {hovered !== null && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-8 pointer-events-none">
            <motion.div
              className="absolute inset-0 bg-black/70"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            />
            <motion.img
              key={hovered}
              src={certificates[hovered].image}
              alt={certificates[hovered].title}
              initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
              animate={{ opacity: 1, scale: 1, rotate: 0 }}
              exit={{ opacity: 0, scale: 0.6, rotate: 8 }}
              transition={{ type: 'spring', stiffness: 260, damping: 22 }}
              className="relative max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
            />
          </div>
        )}
      </AnimatePresence>
    </section>
  );
}

export default React.memo(Certificates);
